import { kebabCase, reduce } from 'lodash-es'

export const objectToString = (obj: any, separator = ';') => {
  return reduce(
    obj,
    (iAcc: string, v: any, k: string) => {
      iAcc += `${kebabCase(k)}: ${v}${separator} `
      return iAcc
    },
    '',
  ).trim()
}
